import React from 'react';
import PassConfirmationForm from './PassConfirmationForm';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DemoAuthTemplate from '../../common/auth-template/AuthTemplate';
import { useAppDispatch } from '../../common/hooks/useAppDispatch';

const PassConfirmation = () => {
  const location = useLocation();
  const invitationURL = location.pathname.includes('join_company');
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  return (
    <DemoAuthTemplate>
      {/*<ClerkLogIn />*/}
      <PassConfirmationForm />
    </DemoAuthTemplate>
  );
};

export default PassConfirmation;
